// extracted by extract-css-chunks-webpack-plugin
module.exports = {"cardsBlock":"cardsBlock___38xkb","cardsHeader":"cardsHeader___24U6S","cards":"cards___2g6v-"};